import React from 'react';
import { Loader } from '@progress/kendo-react-indicators';

interface OverlayedloaderProps {
  show: boolean;
}

const Overlayedloader: React.FC<OverlayedloaderProps> = (props: OverlayedloaderProps) => {
  return (
    <div
      style={{
        display: props.show ? 'flex' : 'none',
        position: 'absolute',
        bottom: 0,
        top: 0,
        right: 0,
        left: 0,
        zIndex: 200,
        justifyContent: 'center',
        backgroundColor: 'rgba(200,200,200,0.6)',
      }}
    >
      <Loader size="small" themeColor={'primary'} />
    </div>
  );
};

export default Overlayedloader;
